export const DASHBOARD_PANEL_CONTEXT_NOTE = 'note';
export const DASHBOARD_PANEL_CONTEXT_WHITEBOARD = 'whiteboard';
export const DASHBOARD_PANEL_CONTEXT_DASHBOARD = 'dashboard';

export type DashboardPanelContextType =
  | typeof DASHBOARD_PANEL_CONTEXT_NOTE
  | typeof DASHBOARD_PANEL_CONTEXT_DASHBOARD;
